module.exports = __webpack_public_path__ + "resource/img/image057Dark.756e9dcb.png";